import React from 'react'

const FinalCTA = () => {
  return (
    <section className="final-cta">
        <div className="container-xl">
            <div className="row">
                <div className="col-12">
                    <div className="cta-content">
                        <h4>Get Freaky, Get Moisturized!</h4>
                        <h2>The <span>all-in-one oil</span> that brings hydration and a hint of fun to your skincare routine. Perfect for dry skin… and, well, other things.</h2>
                        <a className="button cta-btn" href="#prosec">order now</a>
                        <p><img loading='lazy' decoding='async' src="images/safe.svg" width="16" height="24" alt="safe icon"/>Safe & Secure Payment</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default FinalCTA